import { LoadingStatusEnum } from '../../../store/types'

export enum NewsSentimentEnum {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
}

export interface NewsSymbol {
  symbol: string
}

export interface NewsTopic {
  name: string
}

export interface NewsAiAnalysis {
  symbol: NewsSymbol
  sentiment: NewsSentimentEnum
  summary: string
}

export interface NewsItem {
  id: number
  title: string
  text: string
  url: string
  imageUrl?: string
  sourceName: string
  date: string
  sentiment?: NewsSentimentEnum
  rankScore?: number
  topics?: NewsTopic[]
  symbols?: NewsSymbol[]
  aiAnalyses?: NewsAiAnalysis[]
  isAiAnalyzed: boolean
}

export enum NewsOrderByEnum {
  DATE = 'date',
  RANK_SCORE = 'rankScore',
}

export enum NewsPeriodAnalysisTypeEnum {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  LAST7DAYS = 'last7days',
}

export interface NewsPeriodAiAnalysis {
  id: number
  symbol: string
  type: NewsPeriodAnalysisTypeEnum
  startDate: string
  endDate: string
  summary: string
  strengthScore?: number | null
}

export interface GetNewsPeriodAiAnalysisData {
  period?: NewsPeriodAnalysisTypeEnum
  date?: Date
  language?: string
}

export interface FetchNewsParams {
  symbols: string[]
  // page?: number
  // items?: number
  orderBy?: NewsOrderByEnum
  language?: string
  // sentiment?: string
}

export interface TrackAiMarketInsightViewedData {
  pair: string
  language?: string
}

export interface AIMarketInsightsState {
  symbols: {
    list: NewsSymbol[]
    loading: LoadingStatusEnum
  }
  news: {
    list: NewsItem[]
    loading: LoadingStatusEnum
  }
  dailyAnalysis: {
    list: NewsPeriodAiAnalysis[]
    loading: LoadingStatusEnum
  }
  last7DaysAnalysis: {
    list: NewsPeriodAiAnalysis[]
    loading: LoadingStatusEnum
  }
}
